import { render, staticRenderFns } from "./LmNomenclaturasNewOrEdit.vue?vue&type=template&id=72bda05c&scoped=true&"
import script from "./LmNomenclaturasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmNomenclaturasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmNomenclaturasNewOrEdit.vue?vue&type=style&index=0&id=72bda05c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bda05c",
  null
  
)

export default component.exports